module.exports = __webpack_public_path__ + "static/img/success17.98ef7e5c.png";